import { mision, vision } from '@/mocks/multifierros';

export default function MissionVision() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Parallax background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: 'url("https://readdy.ai/api/search-image?query=Underground%20mining%20tunnel%20interior%20with%20multiple%20curved%20steel%20H-beam%20arch%20support%20frames%20installed%20along%20rocky%20walls%2C%20bright%20industrial%20lights%20illuminating%20dark%20passage%2C%20workers%20with%20helmets%20in%20distance%2C%20atmospheric%20dust%20haze%2C%20wet%20rocky%20walls%2C%20deep%20underground%20dramatic%20atmosphere%2C%20cinematic%20industrial%20photography%20photorealistic&width=1600&height=900&seq=parallax-mv&orientation=landscape")',
        }}
      />
      <div className="absolute inset-0 bg-black/75"></div>

      <div className="relative z-10 max-w-[800px] mx-auto px-4 md:px-8 text-center">
        <h2 className="font-heading text-3xl md:text-4xl text-white tracking-wider mb-4">
          Nuestra Misión
        </h2>
        <p className="text-white/80 text-sm md:text-base leading-relaxed italic">
          &ldquo;{mision}&rdquo;
        </p>

        <h2 className="font-heading text-3xl md:text-4xl text-white tracking-wider mt-10 mb-4">
          Nuestra Visión
        </h2>
        <p className="text-white/80 text-sm md:text-base leading-relaxed italic">
          &ldquo;{vision}&rdquo;
        </p>
      </div>
    </section>
  );
}